export default __webpack_public_path__ + "static/media/56.aa0e2b54.jpg";